
import {defineComponent} from "vue";
import store from "@/store";
import LocaleChanger from "@/components/UI/LocaleChanger.vue";
import AppDrawer from "@/components/layouts/AppDrawer.vue";
import {AppEnum} from "@/models/enum/AppEnum";
import {AuthContext} from "@/context/AuthContext";
import {CustomerContext} from "@/context/CustomerContext";
import {UtilityHelper} from "@/helpers/UtilityHelper";
import {TrainingsRestService} from "@/services/rest/trainings/TrainingsRestService";
import {mapGetters} from "vuex";
import {CustomerDomainOverviewRestDto} from "@/api/pharma-customer-settings/models";
import {AbilityContext} from "@/context/AbilityContext";
import { AuthRestService } from "@/services/rest/AuthRestService";
import { AuthService } from "@/services/business/AuthService";
import BaseModalButton from "@/components/UI/Bootstrap/Modal/BaseModalButton.vue";
import UserModeBadge from "@/components/layouts/user-mode/UserModeBadge.vue";
import UserModeDialog from "@/components/layouts/user-mode/UserModeDialog.vue";
import {generateUUIDv4} from "@/helpers/functions/string";

export default defineComponent({
  name: "TheSecondaryMenu",
  components: {LocaleChanger, AppDrawer, BaseModalButton, UserModeBadge, UserModeDialog},
  data: () => ({
    trainingsData: null as Object | null,
    userModeDialogId: generateUUIDv4('modal-user-mode-') as string,
  }),
  computed: {
    AbilityContext() {
      return AbilityContext
    },
    AppEnum() {
      return AppEnum;
    },
    ...mapGetters(['isAuthenticated']),
    ...mapGetters('customer_settings', ['getCustomerMainDomain']),
    AuthContext() {
      return AuthContext;
    },
    CustomerContext() {
      return CustomerContext;
    },
    UtilityHelper() {
      return UtilityHelper;
    },
    customerMainDomain(): CustomerDomainOverviewRestDto | null {
      return this.getCustomerMainDomain ?? null;
    },
    isShowTrainingAndBoh(): boolean {
      return AbilityContext.isAuthorizedForAnyLicense('DP_WEBSITE_STARTER', 'DP_WEBSITE_BASIC', 'DP_WEBSITE_PREMIUM', 'PHARMACOLLECT_APB', 'PHARMACOLLECT_TEMPLATE', 'PHARMACOLLECT_PLUS_TEMPLATE', 'PHARMACOLLECT_PLUS_APB', 'DP_PHARMACY_GROUP_WEBSITE');
    }
  },
  mounted(): void {
    this.findTrainingsData();
  },
  methods: {
    async findTrainingsData(): Promise<void> {
      this.trainingsData = await TrainingsRestService.getInstance().findTrainingsData();
    },
    async login(): Promise<void> {
      await AuthService.getInstance().login();
    },
    async leaveUserMode(): Promise<void> {
      await AuthService.getInstance().leaveUserMode();
    },
    async logout(): Promise<void> {
      await AuthService.getInstance().logout();

      this.$router.replace('/home');
    },
  },
});
